module.exports = __webpack_public_path__ + "img/btcp.c94efc1f.svg";